class CancellableEvent {
    cancelled: boolean = false;
}
class ObserverChangeEvent {
    id?: string;
    types: string[];

    constructor(id: string | undefined, types: string[]) {
        this.id = id;
        this.types = types;
    }
}
class ObserverEvent {

}
class ObserverPhotoEvent
    extends ObserverEvent {

}
class ObserverBarcodeEvent
    extends ObserverEvent {

}